export const DATE_FORMAT = {
  TIME_AND_DATE: 'HH:mm:ss dd.MM.yyyy',
  HOURS_MINS: 'HH:mm',
  DATE: 'dd MMM yyyy',
  FULL_TIME: 'HH:mm:ss.SSS',
  FULL_TIME_AND_ZONE_FORMAT: 'HH:mm:ss.SSS O',
  DATE_TIME_ZONE_FORMAT: 'MMM dd, yyyy HH:mm (O)',
};
